export default __webpack_public_path__ + "static/media/06.449b2e50.png";